import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../constants';
import { Workflow } from '../../types';
import { Http } from '../../services/Http';

async function fetchWorkflows(): Promise<Workflow[]> {
  const { data } = await Http.axios.get<Workflow[]>('/workflow');
  return data;
}

/**
 * Active approval workflows, used by the user administration form to populate the "Approval Workflow"
 * dropdown and to drive relation-picker visibility (Manager / SVP Manager) from each workflow's
 * approvalStages. Workflows change rarely, so the result is cached aggressively.
 */
export const useWorkflows = () => {
  return useQuery([QUERY_KEYS.WORKFLOWS], fetchWorkflows, {
    staleTime: Infinity,
    refetchInterval: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
  });
};
